"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeRateService = void 0;
const service_1 = require("@phishtool/service");
const exchange_rates_1 = __importDefault(require("~server/controllers/service/exchange-rates"));
class ExchangeRateService extends service_1.Service {
    constructor() {
        super(...arguments);
        this.useGetExchangeRates = this.addCollectionNonResourceQuery({
            routeId: 'rates',
            controller: exchange_rates_1.default,
            middleware: [],
            opts: {
                staleTime: Infinity,
            },
        });
    }
}
exports.ExchangeRateService = ExchangeRateService;
